import { Outlet } from 'react-router-dom';
import Footer from '../components/Footer';
import Header from '../components/Header';
import React from 'react';



const Layout = ({footerHide}) => {
 
  return (
    <div>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer footerHide={footerHide}/>
    </div>
  );
};

export default Layout;
